/* Copy-to-clipboard for phone and email blocks. Progressive: if the
   clipboard API is unavailable the address is still visible text and
   the link still works. */
(function () {
  'use strict';

  function announce(root, message) {
    var live = root.querySelector('.abc-ca__live');
    if (live) { live.textContent = message; }
  }

  function legacyCopy(text) {
    try {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      var ok = document.execCommand('copy');
      document.body.removeChild(ta);
      return ok;
    } catch (e) { return false; }
  }

  function flash(btn, root, text) {
    btn.classList.add('is-copied');
    announce(root, text + ' copied to clipboard');
    window.setTimeout(function () {
      btn.classList.remove('is-copied');
      announce(root, '');
    }, 2200);
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest ? event.target.closest('.abc-ca__copy') : null;
    if (!btn) { return; }
    var text = btn.getAttribute('data-copy');
    if (!text) { return; }
    var root = btn.closest('.abc-ca') || document;

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).then(function () {
        flash(btn, root, text);
      }).catch(function () {
        if (legacyCopy(text)) { flash(btn, root, text); }
      });
    } else if (legacyCopy(text)) {
      flash(btn, root, text);
    }
  });
})();
